// extracted by mini-css-extract-plugin
export var label = "_fk-2";
export var slideContainer = "_fk-0";
export var slider = "_fk-1";